import { useCallback, useRef } from "preact/hooks";
import { useApp } from "~/core/store";
import { UseDiscoveryItemParams } from "./interfaces";
import { parseActionString } from "./utils";

const useDiscoveryItem = ({
    tag,
    id,
    ctx,
    open,
    calculateCoords,
}: UseDiscoveryItemParams) => {
    const {
        help: { processActions, activeHistoryRecord },
    } = useApp();
    const ref = useRef<HTMLDivElement>(null);

    const handleContentClick = useCallback(
        async (event: MouseEvent) => {
            const target = event.target;

            if (!(target instanceof HTMLElement)) {
                return;
            }

            const actionStr = target.dataset.dAction;

            if (!actionStr) {
                return;
            }

            const container = target.closest<HTMLElement>(
                "[data-discovery-container]",
            );
            const actions = parseActionString(actionStr);
            const finalCtx = {
                ...ctx,
                $id: id,
                scrollTop: container?.scrollTop ?? 0,
            };

            await processActions(actions, tag, finalCtx);

            if (
                actions.some(
                    (action) => action.key === "admin_time_open_sidebar",
                )
            ) {
                calculateCoords?.();
            }
        },
        [tag, id, ctx, calculateCoords, processActions],
    );

    const checkScrollTop = useCallback(() => {
        const activeRecord = activeHistoryRecord.peek();
        const element = ref.current;

        if (activeRecord?.tag === tag && open && element) {
            const scrollTop = Number(activeRecord.ctx?.scrollTop ?? 0);

            if (scrollTop && !isNaN(scrollTop)) {
                element.scrollTop = scrollTop;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tag, open]);

    return { ref, handleContentClick, checkScrollTop };
};

export default useDiscoveryItem;
